module.exports = __webpack_public_path__ + "static/feature-integrations-09426af93af0247a2a09386426679d83.png";